import { makeStyles } from "@material-ui/styles";
import { CELL_HEIGHTS, CELL_WIDTHS } from "@utils";

export default makeStyles(() => ({
  root: {
    display: "flex",
    height: CELL_HEIGHTS.LARGE,
  },
  periods: {
    display: "flex",
    height: "100%",
  },
  cell: {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto",
    justifyContent: "center",
    width: CELL_WIDTHS.VALUE.SMALL,
    height: "100%",
    borderRight: "1px solid transparent",
    pointerEvents: "none",
  },
}));
